(() => {
  'use strict';

  const PREVIEW_THEME_PATTERN = /^\d{6,20}$/;
  const PREVIEW_ROLES = new Set(['development', 'unpublished']);

  function getPreviewThemeId(currentUrl) {
    const theme = window.Shopify?.theme;
    if (!PREVIEW_ROLES.has(theme?.role)) return null;

    const queryThemeId = currentUrl.searchParams.get('preview_theme_id');
    if (queryThemeId && PREVIEW_THEME_PATTERN.test(queryThemeId)) return queryThemeId;

    const runtimeThemeId = String(theme?.id || '');
    return PREVIEW_THEME_PATTERN.test(runtimeThemeId) ? runtimeThemeId : null;
  }

  function preservePreviewParameters() {
    const currentUrl = new URL(window.location.href);
    const previewThemeId = getPreviewThemeId(currentUrl);

    if (!previewThemeId) return;

    document.querySelectorAll('a[href*="view=titan-player-scan-v2"]').forEach((link) => {
      try {
        const targetUrl = new URL(link.href, window.location.origin);
        if (targetUrl.origin !== window.location.origin) return;

        targetUrl.searchParams.set('preview_theme_id', previewThemeId);
        if (currentUrl.searchParams.get('pb') === '0') targetUrl.searchParams.set('pb', '0');
        link.href = targetUrl.toString();
      } catch {
        // Invalid merchant-configured URLs remain unchanged and usable as authored.
      }
    });
  }

  function connectAiEntry() {
    const entry = document.querySelector('.tps-entry');
    if (!entry) return;
    document.documentElement.classList.add('tps-entry-page-active');
    document.body.classList.add('tps-entry-page-active');
    const aiEntry = entry?.querySelector('[data-tps-ai-entry]');
    const legacyLauncher = document.getElementById('tgv3Launcher');
    const openButton = document.getElementById('tgConsultOpen');
    if (!aiEntry || !legacyLauncher || !openButton) return;

    legacyLauncher.hidden = true;
    aiEntry.addEventListener('click', (event) => {
      event.preventDefault();
      openButton.click();
    });
  }

  preservePreviewParameters();
  connectAiEntry();
})();
